module.exports = __webpack_public_path__ + "static/media/S1N8-5.123186a0.svg";